export const ValidateSuccess = (respon) => {
  switch (respon.type) {
    case "SUCCESS_LOGOUT":
      return "Logout Berhasil";
    case "SUCCESS_LOGIN":
      return "Login Berhasil";
    case "SUCCESS_REQUEST_OTP":
      return "Permintaan OTP Berhasil";
    case "SUCCESS_VALIDATE_OTP":
      return "Validasi OTP Berhasil";
    case "SUCCESS_VALIDATE_SECURITY_CODE":
      return "Validasi Kode Keamanan Berhasil";
    case "SUCCESS_VALIDATE_SECURITY_CODE_TOKEN":
      return "Validasi Kode Keamanan Token Berhasil";
    case "SUCCESS_GET_OTP_CONFIG":
      return "Konfigurasi OTP Berhasil Didapatkan";
    case "SUCCESS_UPDATE_OTP_CONFIG":
      return "Konfigurasi OTP Berhasil Dirubah";
    case "SUCCESS_CREATED":
      return "Berhasil Dibuat";
    case "SUCCESS_UPDATED":
      return "Berhasil Dirubah";
    case "SUCCESS_DELETED":
      return "Berhasil Dihapus";
    case "OK":
      return "Berhasil";
    case "":
      return "Berhasil";
    default:
      return respon.type;
  }
};

export const ValidateError = (respon, config) => {
  // console.log(respon, "ValidateError");
  var message = respon.message || respon.detail || respon.detail?.type;
  // console.log(message, "message");
  if (message && isJson(message.substring(6)))
    message = JSON.parse(message.substring(6))[0].message;
  console.log(message);
  return message;
};

const isJson = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};
